import { createContext, useContext } from "react";

export type IRadioGroupContext = {
  name: string;
  onChange: (value: any) => void;
  defaultValue: any;
  currentValue?: any;
  disabled?: boolean;
};

export const RadioGroupContext = createContext<IRadioGroupContext>({} as any);

export const useRadioGroupContext = () => useContext(RadioGroupContext);
